import { createFileRoute } from '@tanstack/react-router';
import { GiveawaySetupPage } from '@/features/marketing';

/** A giveaway campaign's setup — `/marketing/campaigns/{id}/giveaway` (its page is built from these settings). */
export const Route = createFileRoute('/_auth/$orgId/marketing/campaigns_/$campaignId_/giveaway')({
  component: GiveawaySetupRoute,
});

function GiveawaySetupRoute() {
  const { orgId, campaignId } = Route.useParams();
  return <GiveawaySetupPage orgId={orgId} campaignId={campaignId} />;
}
